import { SwipeableDrawer, Divider } from '@mui/material';
import {
  IconX,
  IconUser,
  IconShip,
  IconBrandInstagram,
  IconBrandFacebook,
  IconPhone,
  IconCopyright,
  IconMail,
  IconBrandLine,
} from '@tabler/icons-react';
import { FC } from 'react';
import { iOS } from '../../../common/helpers/deviceDetectionHelper';
import { useAuth0 } from '../../../auth/AuthProvider';
import { Link, useNavigate } from 'react-router-dom';

interface Props {
  isShowDrawer: boolean;
  setIsShowDrawer: (isShowDrawer: boolean) => void;
}

const DrawerMenu: FC<Props> = ({ isShowDrawer, setIsShowDrawer }) => {
  const { isAuthenticated, logout } = useAuth0();
  const navigate = useNavigate();

  const handleLogin = () => {
    localStorage.setItem(
      'redirectAfterLogin',
      window.location.pathname + window.location.search,
    );
    setIsShowDrawer(false);
    navigate('/login');
  };

  return (
    <SwipeableDrawer
      anchor="left"
      open={isShowDrawer}
      onClose={() => setIsShowDrawer(false)}
      onOpen={() => setIsShowDrawer(true)}
      disableBackdropTransition={!iOS}
      disableDiscovery={iOS}
    >
      <div className="max-w-xs py-3 px-4 w-full">
        <div className="flex justify-between">
          <button
            type="button"
            onClick={() => setIsShowDrawer(false)}
            aria-label="Close menu"
            className="flex min-h-11 min-w-11 items-center justify-center"
          >
            <IconX size={20} />
          </button>
          <Link to="/" onClick={() => setIsShowDrawer(false)}>
            <img
              src="https://imagedelivery.net/KQLaZdBjDzxarhwBRuqRFg/33a0d3dd-4713-44fc-2792-1237db489400/public"
              width={120}
              alt="santtai-logo"
            />
          </Link>
        </div>
        {isAuthenticated ? (
          <div className="mt-4 py-3 px-6 rounded-lg text-xs font-semibold">
            <button
              type="button"
              className="flex items-center py-2 justify-center w-full bg-brand-santtai-primary text-neutral-00 rounded-lg"
              onClick={() => {
                setIsShowDrawer(false);
                navigate('/profile');
              }}
              aria-label="Profile"
            >
              <IconUser size={20} />
              <span className="pl-2">Profile</span>
            </button>
            <button
              type="button"
              className="flex items-center py-2 justify-center w-full mt-4 bg-neutral-00 text-neutral-800 rounded-lg border border-neutral-100"
              onClick={() => {
                setIsShowDrawer(false);
                navigate('/app/tripmanagement');
              }}
              aria-label="My trips"
            >
              <IconShip size={20} />
              <span className="pl-2">My trips</span>
            </button>
            <button
              type="button"
              onClick={() => logout()}
              className="flex items-center py-2 justify-center w-full mt-4 bg-neutral-00 text-neutral-800 rounded-lg"
              aria-label="Logout"
            >
              <IconUser size={20} />
              <span className="pl-2">Logout</span>
            </button>
          </div>
        ) : (
          <div className="mt-4 py-3 px-6 bg-brand-santtai-primary text-neutral-00 rounded-lg text-xs font-semibold">
            <button
              className="flex items-center justify-center w-full"
              onClick={handleLogin}
            >
              <IconUser size={20} />
              <span className="pl-2">Login or sign up</span>
            </button>
          </div>
        )}

        {/* <div className="mt-4 py-2 text-sm">
          <button className="flex items-center">
            <div className="text-neutral-500">Language</div>
            <div className="pl-4 flex items-center text-neutral-800">
              <span className="font-bold">English</span>
              <span className="ml-1">
                <IconChevronDown size={16} />
              </span>
            </div>
          </button>
        </div> 
        <div className="py-2 text-sm">
          <button className="flex items-center">
            <div className="text-neutral-500">Currency</div>
            <div className="pl-4 flex items-center text-neutral-800">
              <span className="font-bold">Thai baht (THB)</span>
              <span className="ml-1">
                <IconChevronDown size={16} />
              </span>
            </div>
          </button>
        </div>*/}
        <div className="mt-4">
          <Divider />
        </div>
      </div>
      <div className="py-3 px-4 w-full">
        <div className="font-semibold">Liveaboard trips</div>
        <div>
          <div className="mt-4 text-sm font-semibold">Indonesia</div>
          <div className="mt-3 pl-4 text-sm text-neutral-500">
            <Link
              to="/routes/bali"
              className="w-full flex no-underline text-neutral-500"
              onClick={() => setIsShowDrawer(false)}
            >
              Bali
            </Link>
          </div>
          <div className="mt-3 pl-4 text-sm text-neutral-500">
            <Link
              to="/routes/komodo"
              className="w-full flex no-underline text-neutral-500"
              onClick={() => setIsShowDrawer(false)}
            >
              Komodo
            </Link>
          </div>
          <div className="mt-3 pl-4 text-sm text-neutral-500">
            <Link
              to="/routes/lembeh"
              className="w-full flex no-underline text-neutral-500"
              onClick={() => setIsShowDrawer(false)}
            >
              Lembeh Strait
            </Link>
          </div>
          <div className="mt-3 pl-4 text-sm text-neutral-500">
            <Link
              to="/routes/raja-ampat"
              className="w-full flex no-underline text-neutral-500"
              onClick={() => setIsShowDrawer(false)}
            >
              Raja Ampat
            </Link>
          </div>
        </div>
        <div>
          <div className="mt-4 text-sm font-semibold">Thailand</div>
          <div className="mt-3 pl-4 text-sm text-neutral-500">
            <Link
              to="/routes/north-andaman"
              className="w-full flex no-underline text-neutral-500"
              onClick={() => setIsShowDrawer(false)}
            >
              North Andaman
            </Link>
          </div>
          <div className="mt-3 pl-4 text-sm text-neutral-500">
            <Link
              to="/routes/south-andaman"
              className="w-full flex no-underline text-neutral-500"
              onClick={() => setIsShowDrawer(false)}
            >
              South Andaman
            </Link>
          </div>
          <div className="mt-3 pl-4 text-sm text-neutral-500">
            <Link
              to="/routes/koh-tao"
              className="w-full flex no-underline text-neutral-500"
              onClick={() => setIsShowDrawer(false)}
            >
              Koh Tao
            </Link>
          </div>
          <div className="mt-3 pl-4 text-sm text-neutral-500">
            <Link
              to="/routes/deep-south"
              className="w-full flex no-underline text-neutral-500"
              onClick={() => setIsShowDrawer(false)}
            >
              Koh Lipe
            </Link>
          </div>
          <div className="mt-3 pl-4 text-sm text-neutral-500">
            <Link
              to="/routes/koh-losin"
              className="w-full flex no-underline text-neutral-500"
              onClick={() => setIsShowDrawer(false)}
            >
              Losin
            </Link>
          </div>
        </div>
      </div>
      <div className="mt-4 pb-16 text-sm">
        <div className="m-3 p-3 bg-neutral-50 rounded-lg">
          <div className="font-bold">Contact us</div>
          <div className="mt-3 flex">
            <a
              href="https://www.instagram.com/santtaiofficial/"
              target="_blank"
              className="p-2 mr-2 rounded-full bg-brand-secondary text-white"
            >
              <IconBrandInstagram size={16} />
            </a>
            <a
              className="p-2 mr-2 rounded-full bg-brand-secondary text-white"
              href="https://www.facebook.com/santtaiOA"
              target="_blank"
            >
              <IconBrandFacebook size={16} />
            </a>
            <a
              className="p-2 mr-2 rounded-full bg-brand-secondary text-white"
              href="https://lin.ee/hrIH5m4"
              target="_blank"
            >
              <IconBrandLine size={16} />
            </a>
            <a
              href="mailto:hello@santtai.com"
              className="p-2 mr-2 rounded-full bg-brand-secondary text-white"
            >
              <IconMail size={16} />
            </a>
          </div>
          <div className="mt-3 flex items-center text-neutral-500">
            <IconPhone size={16} />
            <span className="ml-1">(+66) 89 130 8888</span>
          </div>
        </div>
        <div className="mt-4 px-3 text-neutral-300 text-xs">
          <div>
            <Link
              to="/privacypolicy"
              className="no-underline text-neutral-300"
              onClick={() => setIsShowDrawer(false)}
            >
              Terms and conditions
            </Link>
            <span className="mx-1">|</span>{' '}
            <Link
              to="/privacypolicy"
              className="no-underline text-neutral-300"
              onClick={() => setIsShowDrawer(false)}
            >
              Privacy policy
            </Link>
          </div>
        </div>
        <div className="mt-2 px-3 text-neutral-300 text-xs">
          <div className="flex items-center">
            <IconCopyright size={12} />
            <span className="ml-1">Santtai, inc.</span>
          </div>
        </div>
      </div>
    </SwipeableDrawer>
  );
};

export default DrawerMenu;
